import React from 'react';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <section id="hero" className="hero container">
      <motion.div
        className="hero-inner"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="hero-text">
          <h1>
            Hi, I'm{' '}
            <span style={{ color: '#00bf63' }}>Adrian</span>
          </h1>
          <p className="lead">
            Software developer specializing in building maintainable web
            applications and crafting intuitive, engaging user experiences.
          </p>
          <div className="hero-actions">
            <a className="btn" href="/Adrian_Galvan_Resume.pdf" download>
              Download Resume
            </a>
            <a className="btn ghost" href="#projects">
              View Projects
            </a>
          </div>
        </div>

        <div className="hero-photo">
          <img src="/face.png" alt="Adrian Galvan" />
        </div>
      </motion.div>
    </section>
  );
}
